<style scoped lang="less">
.layout{width: 424px;height: 220px;background: rgba(34, 85, 172, 0.88);-webkit-filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2)); filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2));overflow: hidden;transform: translate(-50%, -50%);border: 1px solid #6491e0;border-radius: 6px;}
.title{height: 35px;background-color: #2080ff;margin: 0;line-height: 35px;text-align: right;padding: 0 20px;color: #fff; font-size: 16px;display: flex;justify-content: space-between;}
.popup-tool {height: 45px;line-height: 45px;color: #fff; font-family: Microsoft YaH;text-align: left;padding: 0px 10px;border:solid 1px rgb(33, 185, 191)}
.popup-content {color: #d6d4d4; font-family: Microsoft YaH;text-align: left;padding: 5px;border-top: none;}
.ol-popup-closer:after {content: "✖";color: #fff;}
/deep/.el-input.is-disabled .el-input__inner {background: rgba(10, 17, 43, 0.4);border: solid 1px #3c818d;}
/deep/.el-select .el-input.is-disabled .el-input__inner:hover {border: solid 1px #3c818d;}
/deep/.el-form-item__label {padding: 0;color: #fff;text-align: center;}
/deep/.el-form-item {margin: 15px;}
/deep/.el-input__inner {color: #000;}
.markbox {height: 40px;width: 250px;display: flex;flex-direction: row; justify-content:space-around;padding: 0;margin: 0;list-style: none;}
.el-radio-button {width: 40px;height: 40px;}
/deep/.el-radio-button__inner {width: 40px;height: 40px;}
/deep/.el-radio-button__inner img{width: 40px;height: 40px;position: absolute;top: 0px;left: 0px;}
.el-button {border-radius: 4px;border: solid 1px #2080ff;}
.el-button--primary {color: #FFF;background-color: #2080ff;}
.el-button--default {color: #FFF;background: #2080ff;}
/deep/.el-input__inner{ background-color: transparent !important; border: solid 1px #7ae9ff;border-radius: 5px;color: #fff;}
</style>

<template>
<div class="layout" v-drag v-if="flag">
    <p class="title">
      <span>坐标定位</span>
      <a href="#" id="popup-closer" class="ol-popup-closer" @click="closePul(false)"></a>
    </p>
    <div class="popup-content">
      <el-form ref="form" :model="form" label-width="90px">
        <el-form-item label="经度：">
          <el-input v-model="form.longitude"></el-input>
        </el-form-item>
        <el-form-item label="纬度：">
          <el-input v-model="form.latitude"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">确定</el-button>
          <el-button @click="cancel">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
let point
export default {
  data()
  {
    return {
      flag: false,
      form: {
        longitude: '',
        latitude: ''
      },
      LayernarData: []
    }
  },
  methods: {
    showLP()
    {
      if (this.flag)
        this.flag = false
      else
        this.flag = true
    },
    closePul(show)
    {
      this.flag = show
      this.form = {}
      // 去除画的点
      let layer = Viewer.layers.getLayers().find(item => item.id === 'pointLayer')
      if (point)
        layer.removeOverlay(point)
    },
    onSubmit()
    {
      if (this.form.longitude && this.form.latitude)
        this.clickMark(this.form)
      else
        this.$message({message: '请先输入经纬度', type: 'warning', customClass: 'mzindex'})
    },
    clickMark(val)
    {
      let layer = Viewer.layers.getLayers().find(item => item.id === 'pointLayer')
      point && layer.removeOverlay(point)
      point = new window.cxe.Billboard({lng: val.longitude, lat: val.latitude, alt: 5000}, 'static/index/map-marker1.png')
      point.size = [30, 30]
      layer.addOverlay(point)
      Viewer.camera.flyTo({
        destination: window.Cesium.Cartesian3.fromDegrees(val.longitude, val.latitude, 1485110),
        duration: 4
      })
    },
    cancel()
    {
      this.closePul(false)
      this.clear()
      this.form.longitude = ''
      this.form.latitude = ''
    },
    clear()
    {
      this.LayernarData.forEach(e =>
      {
        e.getSource().clear()
        window.map.removeLayer(e)
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/plugins/app/assembly/kyxxyzt/PositioningBox.vue